export default [
    {
        name: 'Contratos',
        url: '/gescon/apoios/contratos',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-APOIO-CONT-00',
        badge: {
            variant: 'primary',
            text: 'APOIO'
        }
    },
    {
        name: 'Requisições',
        url: '/gescon/apoios/requisicoes',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-APOIO-REQ-00',
        badge: {
            variant: 'primary',
            text: 'APOIO'
        }
    },
    {
        name: 'Pagamentos',
        url: '/gescon/apoios/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'GESCON-APOIO-PAG-00',
        badge: {
            variant: 'primary',
            text: 'APOIO'
        }
    }
]
